import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SmoothScroll from "@/lib/SmoothScroll";
import HashScroller from "@/lib/HashScroller";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import Categories from "@/sections/Categories";
import FeaturedCoaches from "@/sections/FeaturedCoaches";
import HowItWorks from "@/sections/HowItWorks";
import Benefits from "@/sections/Benefits";
import FAQ from "@/sections/FAQ";
import Footer from "@/sections/Footer";
import { useAuth } from "@/context/AuthContext";

export default function Landing() {
  const { coachStatus, loading } = useAuth();
  const navigate = useNavigate();

  // If a signed-in approved coach lands on the homepage, take them straight
  // to their workspace — the marketing page isn't what they came back for.
  useEffect(() => {
    if (loading) return;
    if (coachStatus?.is_coach && coachStatus?.is_approved) {
      navigate("/coach-dashboard", { replace: true });
    }
  }, [loading, coachStatus, navigate]);

  return (
    <SmoothScroll>
      <div className="bg-white text-slate-900 font-body">
        <HashScroller />
        <Nav />
        <main>
          <Hero />
          <FeaturedCoaches />
          <Categories />
          <HowItWorks />
          <Benefits />
          <FAQ />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
